var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5656 14.8996L0.287792 28.1784C-0.0811145 28.5473 -0.0811145 29.145 0.287792 29.5143C0.472011 29.6985 0.714354 29.7909 0.955292 29.7909C1.19717 29.7909 1.4381 29.6985 1.62279 29.5143L15.0014 16.1343L28.3795 29.5125C28.5647 29.6976 28.8061 29.789 29.0475 29.789C29.2889 29.789 29.5303 29.6976 29.715 29.5125C30.0844 29.144 30.0844 28.5468 29.715 28.1775L16.4367 14.8996L29.7234 1.61152C30.0923 1.24261 30.0923 0.644955 29.7234 0.27558C29.3545 -0.0923889 28.7569 -0.0923889 28.3884 0.27558L15.0009 13.664L1.61389 0.276517C1.24357 -0.0919202 0.646854 -0.0919202 0.276542 0.276517C-0.0918958 0.645424 -0.0918958 1.24308 0.276542 1.61245L13.5656 14.8996Z",
    fill: "#1D1D1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseInput);
export default __webpack_public_path__ + "static/media/closeInput.fc7ec792bd6bb9eb8382b9bddb90dac3.svg";
export { ForwardRef as ReactComponent };